import React, { useContext, useEffect, useState } from "react";
import TeacherProfile from "../../Templates/Teachers/TeacherProfile/TeacherProfile";
import { teacherURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";

function TeacherProfilePage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${teacherURL}/${id}`;
  const page = "instructors";
  const statisticsUrl = `${teacherURL}/${id}/statistics`;
  const classesUrl = `${teacherURL}/${id}/classes`;

  const [teacher, setTeacher] = useState({});
  const [classes, setClasses] = useState([]);
  const { data, loading, error } = useFetch(url);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, page);
  const [teacherNumbers, setTeacherNumbers] = useState({});
  const {
    data: TeacherNumbersData,
    loading: TeacherNumbersLoading,
    error: TeacherNumbersError,
  } = useFetch(statisticsUrl);

  const {
    data: classesData,
    loading: classesLoading,
    error: classesError,
  } = useFetch(classesUrl);

  useEffect(() => {
    if (!classesError && !classesLoading && classesData) {
      setClasses(classesData.data);
    }
  }, [classesData, classesLoading, classesError]);

  // const [goSave, setGoSave] = useState(false);
  const [activateClicked, setActivateClicked] = useState(false);
  const [goActivate, setGoActivate] = useState(false);
  // const {
  //   saveState,
  //   loading: addLoading,
  //   newData,
  // } = useSave({
  //   url: `${teacherURL}/${id}/resend-activation`,
  //   goSave,
  //   setGoSave,
  // });

  const { loading: addActivateLoading } = useUpdate({
    url: `${teacherURL}/${id}/status`,
    goEdit: goActivate,
    setGoEdit: setGoActivate,
    newObject: {
      active: !teacher?.active,
    },
    refreshAfter: true,
  });

  useEffect(() => {
    if (!loading && !error && data) {
      setTeacher(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!TeacherNumbersError && !TeacherNumbersLoading && TeacherNumbersData) {
      setTeacherNumbers(TeacherNumbersData?.data?.data);
    }
  }, [TeacherNumbersData, TeacherNumbersLoading, TeacherNumbersError]);

  useEffect(() => {
    setContextData({
      ...contextData,
      page: "instructors",
      data: teacher?.name,
    });
  }, [teacher]);

  return (
    <TeacherProfile
      teacher={teacher}
      setTeacher={setTeacher}
      url={url}
      setGo={setGo}
      loading={loading}
      role={contextData?.role}
      // addLoading={addLoading}
      // setGoSave={setGoSave}
      statistics={teacherNumbers}
      setGoActivate={setGoActivate}
      addActivateLoading={addActivateLoading}
      classes={classes}
      classesLoading={classesLoading}
    />
  );
}

export default TeacherProfilePage;
